import { render, staticRenderFns } from "./EventTypesView.vue?vue&type=template&id=23c9bac1&scoped=true"
import script from "./EventTypesView.vue?vue&type=script&lang=js"
export * from "./EventTypesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c9bac1",
  null
  
)

export default component.exports